<template>
  <div class="yxtbiz-kng-operator" v-loading="loading">
    <template v-if="!loading">
      <!-- !!上传前的展示 -->
      <div v-if="!removeUpload" v-show="showUpload">
        <!-- 1.环境选择 在线课中不需要显示 -->
        <div v-if="mixinConfig.enable && !mixinConfig.onlyPrivate && module !== 'kng'">
          <div>{{ $t('pc_biz_lbl_storeposition'/**请选择存储位置 */) }}</div>
          <yxt-radio-group v-model="uploadConfig.privateEnv">
            <yxt-radio :label="0">{{ $t('pc_kng_courseware_lbl_public_cloud'/**公有云 */) }}</yxt-radio>
            <yxt-radio :label="1">{{ $t('pc_biz_kng_tip_localCloud'/**私有云 */) }}</yxt-radio>
          </yxt-radio-group>
        </div>
        <!-- 2.服务器组 在线课中居中显示 -->
        <div class="yxtbiz-kng-operator__serve mt8" v-if="uploadConfig.privateEnv && mixinConfig.serveGroupList.length && !(!!uploadConfig.privateEnv && !uploadConfig.usable && module === 'kng')">
          <yxt-radio-group v-model="uploadConfig.serverGroupId">
            <yxt-radio
              :label="item.id"
              :key="item.id"
              v-for="item in mixinConfig.serveGroupList"
              >{{ item.serviceGroupName }}
            </yxt-radio>
          </yxt-radio-group>
        </div>
        <div class="yxtbiz-kng-operator__upload">
          <template v-if="!!uploadConfig.privateEnv && !uploadConfig.usable && module === 'kng'">
            <yxtf-empty permission>
              <div slot="text" class="standard-size-20 color-gray-9 mt24">
                <div>{{ $t('pc_kng_courseware_msg_connect_to_server'/** 无法连接到服务器 */) }}</div>
                <div>{{ $t('pc_kng_courseware_msg_check_server_started'/** 如需访问请联系管理人员，检查服务器是否启动 */) }}</div>
              </div>
            </yxtf-empty>
          </template>
          <template v-else>
            <!-- 3.上传组件 在线课中私有云不可用样式不一样 -->
            <kng-upload
              :isPrivate="!!uploadConfig.privateEnv"
              :serverGroupId="uploadConfig.serverGroupId"
              :disabled="!!uploadConfig.privateEnv && !uploadConfig.usable"
              :special-upload="isSpecialUpload"
              :specialFileType="isSpecialUpload ? createFileType : ''"
              :max="10 - infoList.length"
              @add="onAdd"
              @reupload="reupload"
              @update="onUpdate"
            />
            <!-- 4.上传须知 在线课中样式不一样-->
            <kng-upload-tips v-if="!isSpecialUpload" :enableUploadZip="enableUploadZip" :module="module"/>
          </template>
        </div>
      </div>
      <!-- !!上传后的展示 -->
      <template v-if="!showUpload">
        <!-- 多个模式 -->
        <kng-form-multi v-if="multiple" ref="form" :infoList="infoList" @continueUpload="continueUpload"  @delete="del"/>
        <!-- 单个模式 -->
        <kng-form-single v-else-if="infoList.length === 1" ref="form" :info="infoList[0]" @delete="del"/>
      </template>
    </template>
    <!-- 微课选择 -->
    <wei-ke-selector v-if="showWeiKeSelector" ref="selector"/>
    <!-- 知识库选择 -->
    <kng-lib-selector v-if="showKngLibSelector" ref="selector"/>
  </div>
</template>

<script>
import axios from 'axios';
import commonUtil from 'yxt-biz-pc/packages/common-util';
import { KNG_FILE_TYPE, KNG_TYPE } from 'yxt-biz-pc/packages/select-kng/src/const';
import {
  getKngDetail,
  getCustomAttrConfig,
  getMixinConfig,
  getServeGroups,
  getCatalogTreeData,
  getSkillTags,
  getContentTags,
  editKng,
  createKngBatch,
  createKng,
  createNewWeiKeBatch,
  saveCourseDraft,
  getMainServerList,
  getSecretEndpointById,
  getFileInfoByFileId,
  postLocalTranscode,
  commonLog,
  getScoreConfig,
  ulcdReleaseInfo,
  putKngTransError
} from '../service';
import { COURSE_ATTRIBUTE } from '../enum';
// import { formatDate, nextDate } from 'yxt-biz-pc/src/utils/date-util';
import { getScoreWithConfig, getSystemCoverImages, getTreeNodePathByKey, sleep } from '../utils';
import KngUpload from './components/kng-upload.vue';
import kngFormSingle from './components/kng-form-single.vue';
import kngFormMulti from './components/kng-form-multi.vue';
import config from '../mixins/config';
import KngUploadTips from './components/kng-upload-tips.vue';
import { uuid } from 'yxt-biz-pc/packages/upload/src/utils';
import KngLibSelector from './components/kng-lib-selector.vue';
import WeiKeSelector from './components/wei-ke-selector.vue';

export default {
  components: { KngUpload, kngFormSingle, kngFormMulti, KngUploadTips, KngLibSelector, WeiKeSelector },
  name: 'YxtbizKngOperator',
  name_zh: '课件创建',
  eventList: [{
    type: 'change',
    handler: 'onFilesChange',
    label: '继续上传'
  }, {
    type: 'change',
    handler: 'onAddCatalog',
    label: '添加分类'
  }],
  mixins: [config],
  provide() {
    return {
      getIsEdit: () => this.isEdit,
      getAttrConfigs: () => this.attrConfigs,
      getUploadConfig: () => this.uploadConfig,
      getConfig: () => this.config,
      getNavOffsetTop: () => this.navOffsetTop,
      getCatalogData: () => this.catalogData,
      getFunctionCode: () => this.functionCode,
      getCourseId: () => this.courseId,
      getCollegeId: () => this.collegeId_,
      getModule: () => this.module,
      getEnableAddCatalog: () => this.enableAddCatalog,
      getScoreConfig: () => this.scoreConfig,
      getUseInBuyCourse: () => this.useInBuyCourse,
      getMaxLength: () => this.maxLength,
      getSelectableLength: () => this.selectableLength
    };
  },
  props: {
    kngId: {
      type: String,
      default: '',
      desc: '课件id,编辑用',
      setter: 'StringSetter'
    },
    courseId: {
      type: String,
      default: '',
      desc: 'ulcd课程包下的课件编辑需要courseId',
      setter: 'StringSetter'
    },
    collegeId: {
      type: String,
      default: '',
      desc: '课堂Id',
      setter: 'StringSetter'
    },
    module: {
      type: String,
      default: 'ulcd',
      desc: '什么模块创建,ulcd、kng',
      setter: 'StringSetter'
    },
    createFileType: {
      type: String,
      default: '',
      desc: '指定类型的创建scorm、html、xuanyes、newlink 、course',
      setter: 'StringSetter'
    },
    navOffsetTop: {
      type: Number,
      default: 80,
      desc: '导航距离顶部位置',
      setter: 'NumberSetter'
    },
    functionCode: {
      type: String,
      default: 'kng_courseware_mgmt',
      desc: '导航code',
      setter: 'StringSetter'
    },
    env: {
      type: Number,
      default: undefined,
      desc: '指定环境，不指定就是公有云',
      setter: 'NumberSetter'
    },
    enableAddCatalog: {
      type: Boolean,
      default: false,
      desc: '是否显示添加分类',
      setter: 'BooleanSetter'
    },
    isWKCenterCreate: {
      type: Boolean,
      default: false,
      desc: '是否来自微课中心的创建，当createFileType === "xuanyes"时生效',
      setter: 'BooleanSetter'
    },
    useInBuyCourse: {
      type: Boolean,
      default: false,
      desc: '购课中心编辑课件',
      setter: 'BooleanSetter'
    }
  },
  data() {
    return {
      loading: true,
      infoList: [],
      attrConfigs: [], // 自定义属性配置 + _data数据源

      // 上传配置
      uploadConfig: {
        usable: false,
        privateEnv: 0,
        serverGroupId: '',
        serverGroupName: '',
        serverId: '',
        serverName: '',
        secretEndpoint: ''
      },
      // 混部配置
      mixinConfig: {
        enable: false,
        onlyPrivate: false,
        serveGroupList: []
      },
      config: {
        definitionOpened: false,
        sizeLimitOpened: false,
        skillTagOpened: false,
        isBossCanDownload: false,
        isBossCanDownloadVideo: false,
        isBossCanDownloadAudio: false,
        isBossCanDownloadDoc: false,
        forbidDrag: true,
        canUseAI: false,
        openReward: false
      },
      catalogData: { // 分类树数据
        loading: false,
        tree: []
      },
      scoreConfig: {}
    };
  },
  computed: {
    isEdit() {
      return !!this.kngId;
    },
    multiple() {
      return !this.isEdit && !this.createFileType && this.module === 'ulcd' ||
      (this.module !== 'ulcd' && this.infoList.length > 1); // 新微课可以继续添加，后续对接修改
    },
    showUpload() {
      return this.infoList.length === 0;
    },
    // 不需要加载上传组件的情况
    removeUpload() {
      return this.createFileType === KNG_FILE_TYPE.NEWLINK ||
        this.createFileType === KNG_FILE_TYPE.WEIKE ||
        this.createFileType === KNG_FILE_TYPE.COURSE ||
        (this.isEdit && this.infoList[0] && [KNG_FILE_TYPE.NEWLINK, KNG_FILE_TYPE.WEIKE, KNG_FILE_TYPE.COURSE].includes(this.infoList[0].fileType));
    },
    // 特殊指定类型的课件上传： scorm ｜ html
    isSpecialUpload() {
      return [KNG_FILE_TYPE.SCORM, KNG_FILE_TYPE.HTML].includes(this.createFileType);
    },
    showKngLibSelector() {
      return this.createFileType === '' && this.$route.query.tempKey && !this.kngId;
    },
    showWeiKeSelector() {
      return this.isWKCenterCreate;
    },
    maxLength() {
      return ((this.showKngLibSelector || this.showWeiKeSelector) ? 100 : 10);
    },
    selectableLength() {
      return this.maxLength - this.infoList.length;
    },
    collegeId_() {
      return this.collegeId || this.$route.query.collegeId || '';
    }
  },
  watch: {
    infoList(val) {
      this.$emit('onFilesChange', val);
    },
    'uploadConfig.privateEnv'(val) {
      // 选择私有云，获取服务器组列表
      if (val && !this.isEdit) this.setServeGroupConfig();
    },
    'uploadConfig.serverGroupId'(val) {
      this.uploadConfig.serverGroupName = (this.mixinConfig.serveGroupList.find(item => item.id === val) || {}).serviceGroupName;
      // 获取serverId
      getMainServerList(val)
        .then(res => {
          const server = res.find(item => item.serviceType === '1') || {};
          this.uploadConfig.serverId = server.id;
          this.uploadConfig.serverName = server.serviceName;
        });
      if (!this.uploadConfig.secretEndpoint) {
        // 获取endpoint
        getSecretEndpointById(val)
          .then(res => {
            this.uploadConfig.secretEndpoint = res.secretEndpoint;
            this.checkEndpoint();
          });
      }
    }
  },
  async created() {
    try {
      await commonUtil.preCheckFunctions([
        'online_course_skill_label_choose',
        'talentmanagement',
        'kng_tag_display',
        'sdcs_supplier',
        'App_cache_permission_hidden',
        'Tourists_learn',
        'discussion_enable',
        'learning_note',
        'Face_recognition_configuration_in_class',
        'download_mili',
        'AI_subtitles'
      ]);
    } catch (e) {};
    this.init();
    this.$root.$on('ADD_CATALOG', this.addCatalog);
  },
  beforeDestroy() {
    this.$root.$off('ADD_CATALOG', this.addCatalog);
  },
  methods: {
    // 外部调用
    continueUpload() {
      if (this.showKngLibSelector || this.showWeiKeSelector) {
        // 从知识库添加
        // 从微课中心添加
        this.$refs.selector && this.$refs.selector.init().then(res =>this.appendFiles(res));
      } else {
        this.$root.$emit('continueUpload');
      }
    },
    // 外部调用
    appendFiles(list) {
      const _list = list.map(item => ({...item, _uuid: uuid()}));
      if (this.loading) {
        this.needAppendFiles = _list;
        return;
      }
      this.onAdd(_list);
    },
    async checkEndpoint() {
      try {
        await axios.get(`${this.uploadConfig.secretEndpoint}/receive/check`);
        this.uploadConfig.usable = true;
      } catch (error) {
        this.uploadConfig.usable = false;
      }
    },
    /** 初始化 */
    async init() {
      this.loading = true;
      if (!this.useInBuyCourse) {
        this.setCatalogData(); // 该接口耗时太长，改为异步加载
      }
      await Promise.all([
        this.setCustomAttrConfig(),
        this.setSkillTagStatus(),
        this.setUploadLimitConfig(),
        this.setScoreConfig()
      ]);
      if (this.needAppendFiles) {
        this.onAdd(this.needAppendFiles);
        this.needAppendFiles = null;
      }
      if (this.kngId) { // 编辑
        const info = await this.getDetail();
        await this.setCustomAttrConfig(info);
        this.initCustomAttributesOfInfo(info);
        this.infoList = [info];
        this.setContentTags(info);
        if (this.config.skillTagOpened) {
          // 获取能力标签
          this.setSkillTags(info);
        }
        if (info.envFlag === 0) {
          this.uploadConfig.privateEnv = 1;
          this.uploadConfig.serverId = ~~info.serverId;
          this.uploadConfig.serverGroupId = ~~info.serverGroupId;
          this.setFileInfo(info);
        }
      } else if (this.createFileType === KNG_FILE_TYPE.COURSE || this.createFileType === KNG_FILE_TYPE.NEW_LINK) { // 指定类型创建
        const info = {fileType: this.createFileType, title: this.createFileType === KNG_FILE_TYPE.COURSE ? this.$t('pc_kng_course_lbl_unnamed_course') : ''};
        this.initDefaultInfo(info);
        this.initCustomAttributesOfInfo(info);
        this.infoList = [info];
      } else if (['', KNG_FILE_TYPE.HTML, KNG_FILE_TYPE.SCORM].includes(this.createFileType)) { // 创建音视频文档
        await this.setMixinConfig();
      }
      this.loading = false;
    },
    async setCatalogData() {
      try {
        this.catalogData.loading = true;
        const res = await getCatalogTreeData({ collegeId: this.collegeId, pmType: 4 });
        this.catalogData.loading = false;
        this.catalogData.tree = res;
        !this.kngId && this.infoList.forEach(item => {
          this.setDefaultCatalog(item);
        });
      } catch (e) {
        console.log(e);
      }
    },
    async setScoreConfig() {
      try {
        const res = await getScoreConfig();
        this.scoreConfig = res;
      } catch (error) {
        this.$message.error(error.error.message);
        return Promise.reject(new Error('error'));
      }
    },
    // 自定义属性
    async setCustomAttrConfig(info) {
      if ((this.kngId && !info)) return;
      const params = {
        type: info && info.draftId ? 1 : 0,
        kngId: (info && info.draftId) || this.kngId || ''
      };
      try {
        const res = await getCustomAttrConfig(params);
        this.attrConfigs = res.filter(item => !item.disabled);
      } catch (error) {
        this.$message.error(error.error.message);
        return Promise.reject(new Error('error'));
      }
    },
    // 详情
    async getDetail() {
      const [res, error] = await getKngDetail({
        id: this.kngId,
        publishType: ~~this.$route.query.publishType || 2
      });
      if (error) {
        this.$message.error(error.error.message);
        return Promise.reject(new Error('error'));
      }
      res.studyMaterialType = res.studyMaterialType || ''; // 数据库默认0，下拉会展示出来，要重置为''
      return res;
    },
    // 获取内容标签
    async setContentTags(info) {
      const id = info.sourceKngId || info.id;
      const {datas} = await getContentTags(id, info.shareFlag === 2);
      this.$set(info, 'contentTags', datas || []);
    },
    // 获取能力标签
    async setSkillTags(info) {
      const res = await getSkillTags(info.id);
      const skillTags = (res || []).map(item => ({id: item.skillTagId, name: item.skillTagName}));
      this.$set(info, 'skillTags', skillTags);
    },
    async setFileInfo(info) {
      const res = await getFileInfoByFileId(info.fileId);
      info._fileType = res.type;
      info.fileName = res.originName;
      info._keyPath = res.url;
    },
    // 混部基础配置
    async setMixinConfig() {
      const [res, error] = await getMixinConfig();
      if (error) {
        return Promise.reject(new Error('error'));
      }
      const { bizSwith, localSwith } = res;
      this.mixinConfig.enable = localSwith === 1;
      this.mixinConfig.onlyPrivate =
        bizSwith && JSON.parse(bizSwith).onlineClass;
      if ((this.mixinConfig.enable && this.mixinConfig.onlyPrivate) || this.env === 1) {
        await this.setServeGroupConfig();
        this.uploadConfig.privateEnv = 1;
      } else {
        this.uploadConfig.privateEnv = ~~this.env;
      }
    },
    // 私有云服务器配置
    async setServeGroupConfig() {
      if (this.mixinConfig.serveGroupList.length) return;
      const [res, error] = await getServeGroups();
      if (!error) {
        const { localUploadConfig, serviceGroupList } = res;
        this.mixinConfig.serveGroupList = serviceGroupList;

        this.uploadConfig.secretEndpoint =
          localUploadConfig && localUploadConfig.secretEndpoint;
        this.uploadConfig.serverGroupId = this.uploadConfig.serverGroupId ||
          (serviceGroupList && serviceGroupList[0].id);
        if (this.uploadConfig.secretEndpoint) {
          await this.checkEndpoint();
        }
      }
    },
    initCustomAttributesOfInfo(info) {
      if (!info.customAttributes) {
        info.customAttributes = [];
      }
      this.attrConfigs.forEach(item => {
        if (
          item.attrKey === COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE ||
          item.attrKey === COURSE_ATTRIBUTE.CUSTOM_RELATED
        ) {
          let data = info.customAttributes.find(it => it.attrId === item.id);
          if (!data) {
            data = {
              history: item.history,
              attrKey: item.attrKey,
              attrName: item.attrName,
              attrId: item.id,
              userName: item.useName || '',
              value: item.value || this.getAttrValue(item, info)
            };
            info.customAttributes.push(data);
          } else {
            data.attrKey = item.attrKey;
            data.attrName = item.attrName;
          }
        }
      });
    },
    getAttrValue(item, info) {
      if (info.code && item.history === 1) {
        return info.code;
      } else if (info.customVersion && item.history === 2) {
        return info.customVersion;
      }
      // if (
      //   item.attrType === '2' &&
      //   item.attrKey === COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE
      // ) {
      //   if (item.rangeMin) {
      //     return formatDate(
      //       nextDate(new Date(item.rangeMin.replace(/-/g, '/')))
      //     );
      //   }
      // } else if (
      //   item.attrType === '0' &&
      //   item.attrKey === COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE
      // ) {
      //   if (item.rangeMin) {
      //     return item.rangeMin;
      //   }
      //   return Math.min(item.rangeMax || 0, 0);
      // }
      return undefined;
    },
    // 上传回调
    onAdd(list) {
      // 第一次上传是否是多选的
      const res = list.map(item => {
        const title = item.title || item.fileName.substring(0, item.fileName.lastIndexOf('.'));
        const info = {
          ...item,
          title
        };
        if (this.isSpecialUpload) {
          // scorm & html 上传
          info.fileType = this.createFileType;
        }
        this.initDefaultInfo(info);
        this.initCustomAttributesOfInfo(info);
        return info;
      });
      this.infoList = [...res, ...this.infoList];
      this.$forceUpdate();
    },
    reupload(file) {
      const { fileType, type } = this.infoList[0];
      if (type === KNG_TYPE.DOC) {
        // 文档课件更新时不限制新上传的文件格式
        this.infoList.splice(0, 1, { ...this.infoList[0], ...file, oldFileType: fileType });
      } else {
        this.infoList.splice(0, 1, {...this.infoList[0], ...file, fileType}); // 编辑的fileType以接口为准
      }
    },
    onUpdate(file) {
      const obj = this.infoList.find(item =>item._uuid && item._uuid === file._uuid);
      if (obj) {
        if (obj._isReupload) obj.newFileId = file.fileId;
        else obj.fileId = file.fileId;
        obj._status = file._status;
        obj._error = file._error;
        obj._percentage = file._percentage;
        obj._abort = file._abort;
        obj._keyPath = file._keyPath;
      }
    },
    initDefaultInfo(info) {
      if ([KNG_FILE_TYPE.IMAGE, KNG_FILE_TYPE.EXCEL, KNG_FILE_TYPE.WORD, KNG_FILE_TYPE.PPT, KNG_FILE_TYPE.PDF].includes(info.fileType)) {
        info.type = KNG_TYPE.DOC;
      } else if ([KNG_FILE_TYPE.VIDEO].includes(info.fileType)) {
        info.type = KNG_TYPE.VIDEO;
        info.enableDrag = 1 - this.config.forbidDrag;
      } else if ([KNG_FILE_TYPE.AUDIO].includes(info.fileType)) {
        info.type = KNG_TYPE.AUDIO;
        info.enableDrag = 1 - this.config.forbidDrag;
      } else if ([KNG_FILE_TYPE.WEIKE].includes(info.fileType)) {
        info.type = KNG_TYPE.WEIKE;
      } else if ([KNG_FILE_TYPE.ZIP].includes(info.fileType)) {
        info.type = KNG_TYPE.ZIP;
      } else if ([KNG_FILE_TYPE.SCORM].includes(info.fileType)) {
        info.type = KNG_TYPE.SCORM;
        info.studyHours = 10 * 60; // 创建scorm默认10分钟
      } else if ([KNG_FILE_TYPE.HTML].includes(info.fileType)) {
        info.type = KNG_TYPE.HTML;
        info.studyHours = 10 * 60; // 创建html默认10分钟
      } else if ([KNG_FILE_TYPE.NEW_LINK].includes(info.fileType)) {
        info.type = KNG_TYPE.NEWLINK;
      } else if ([KNG_FILE_TYPE.COURSE].includes(info.fileType)) {
        info.type = KNG_TYPE.COURSE;
      }
      if ([KNG_FILE_TYPE.VIDEO, KNG_FILE_TYPE.AUDIO, KNG_FILE_TYPE.WEIKE, KNG_FILE_TYPE.COURSE].includes(info.fileType)) {
        const {enabled, multipleMode, multipleStudy} = this.multiConfig;
        if (enabled === 1) {
          info.enableMultipleSwitch = 1;
          info.enableMultiple = multipleMode === 1 ? multipleStudy : 1;
        }
      }
      info.price = 0;
      info.photoType = info.coverUrl ? 0 : 1;
      info.coverUrl = info.coverUrl || getSystemCoverImages();
      if (this.courseId) { // ulcd中上传，默认隐藏
        info.visiable = 0;
      } else {
        info.visiable = 1;
      }
      if (info.studyHours) {
        info.studyScore = getScoreWithConfig(info, this.scoreConfig);
      }
      info.expireHours = 0;
      info.expireDay = 0;
      info.browsePermissions = [];
      info.watermarkFlag = 0;
      info.contributorsUser = localStorage.userId || '';
      info.contributorsName = localStorage.fullname || '';
      info.distributeSourceType = 0;
      info.visitorConfDTO = {};
      info.faceRecognitionConfig = {};
      info.enableStudyedAlert = 1;
      info.shareEnabled = 1;
      info.appEnabled = 1;
      this.setDefaultCatalog(info);
      if (this.uploadConfig.privateEnv) {
        info.serverGroupId = this.uploadConfig.serverGroupId;
        info.serverGroupName = this.uploadConfig.serverGroupName;
      }
    },
    setDefaultCatalog(info) {
      if (info.catalogId) return;
      if (this.catalogData.tree.length && this.catalogData.tree[0].children && this.catalogData.tree[0].children.length) {
        const { catalogId } = this.$route.query;
        let obj = this.catalogData.tree[0].children[0];
        if (catalogId) {
          const ret = getTreeNodePathByKey(catalogId, this.catalogData.tree).node;
          if (ret) {
            if (ret.id === ret.collegeId && ret.children && ret.children.length) {
              obj = ret.children[0];
            } else if (ret.id !== ret.collegeId) {
              obj = ret;
            }
          }
        }
        this.$set(info, 'catalogId', obj.id);
        this.$set(info, 'catalogName', obj.label);
        this.$set(info, 'collegeId', obj.collegeId);
      } else {
        this.$set(info, 'catalogId', '');
        this.$set(info, 'catalogName', '');
        this.$set(info, 'collegeId', '');
      }
    },
    // 删除文件
    del(info) {
      const index = this.infoList.indexOf(info);
      index > -1 && this.infoList.splice(index, 1);
    },
    // 创建 or 编辑
    async confirm() {
      const infoList = JSON.parse(JSON.stringify(this.infoList));
      if (this.showUpload) {
        this.$message.warning(this.$t('pc_biz_lbl_uploadfilefirst'/** 请先上传文件！ */));
        return Promise.reject(new Error('fail'));
      } else if (infoList.some(item => item._status !== undefined)) {
        this.$message.warning(this.$t('pc_biz_lbl_fileuncomplete'/** 有文件未上传完成，无法提交！ */));
        return Promise.reject(new Error('fail'));
      }
      await this.$refs.form.validate();
      // 处理请求数据
      infoList.forEach(item => {
        if (item.browsePermissions) item.browsePermissions.forEach(i => (i.id = i.userGroupId));
        if (item.appDownloadPermissions) item.appDownloadPermissions.forEach(i => (i.id = i.userGroupId));
        if (item.downloadPermissions) item.downloadPermissions.forEach(i => (i.id = i.userGroupId));
        item.customAttributes = item.customAttributes.filter(attr => (attr.history !== 1 && attr.history !== 2));
        item.markTagIds = (item.contentTags || []).map(item => item.id);
        item.skillTagIds = (item.skillTags || []).map(item => ({skillId: item.id}));
      });
      // 发起请求
      let responses;
      if (this.isEdit) {
        // 编辑
        infoList[0].newFontSize = infoList[0].fontSize; // 编辑接口属性不一样，keng
        // draftState： 1双版本
        const [res, error] = await editKng({...infoList[0], ulcdCourseId: this.courseId});
        if (error) {
          if (error.error.key === 'apis.kng.subtitles.account.error') {
            this.$root.$emit('ai_fail');
          }
          this.$message.error(error.error.message);
          return Promise.reject(new Error('fail'));
        }
        responses = [res];
        if (this.createFileType === KNG_TYPE.COURSE && infoList[0].shareFlag !== 2) {
          // 非集团版分享的课程编辑时调用
          await ulcdReleaseInfo(infoList[0].id);
        }
      } else {
        // 创建
        infoList.forEach(item => {
          item.serverId = this.uploadConfig.serverId;
          item.serverName = this.uploadConfig.serverName;
          item.envFlag = this.uploadConfig.serverGroupId ? 0 : 1;
          item.ulcdCourseId = this.courseId;
        });
        if (this.createFileType === KNG_FILE_TYPE.COURSE) {
          const {markTagIds, skillTagIds, ...other} = infoList[0];
          const [res, error] = await createKng(other);
          if (error) {
            this.$message.error(error.error.message);
            return Promise.reject(new Error('fail'));
          }
          responses = [{kngId: res.id, state: res.state, ulcdCode: res.ulcdCode }];
          const [, err] = await saveCourseDraft({markTagIds, skillTagIds, ...other, id: res.id});
          if (err) {
            this.$message.error(err.error.message);
            return Promise.reject(new Error('fail'));
          }
        } else {
          const createApi = this.createFileType === KNG_FILE_TYPE.WEIKE && this.isWKCenterCreate ? createNewWeiKeBatch : createKngBatch;
          const [res, error] = await createApi(infoList);
          if (error) {
            this.$message.error(error.error.message);
            return Promise.reject(new Error('fail'));
          }
          responses = res;
        }
      }
      // 重复的
      const repeatNumber = responses.filter(item => item.state === 1).length;
      // 失败的
      const errorNumber = responses.filter(item => item.state === 2).length;
      const addedInfoList = infoList.filter((_, index) => responses[index].state !== 1 && responses[index].state !== 2);
      responses = responses.filter(item => item.state !== 1 && item.state !== 2);
      await this.handleLocalTranscode(responses, addedInfoList);

      if (!this.multiple) {
        const auditNumber = responses.filter(item => item.state === 3).length;
        if (errorNumber || repeatNumber) {
          const msg = errorNumber ? this.$t('pc_biz_kng_lbl_retrylater'/** 创建失败，请稍后再试～ */) : this.$t('pc_kng_msg_knguploadedincatalog'/** 此课件在该分类中已存在，请不要重复上传哦~ */);
          await this.$confirm(
            msg,
            this.$t('pc_biz_lbl_tip'),
            {
              type: 'warning',
              showCancelButton: false
            });
        } else if (auditNumber) {
          this.$message({
            message: this.$t('pc_kng_mgmt_tip_publishedToApproval'/* 您已提交发布，审核通过后将自动发布 */),
            type: 'success'
          });
          await sleep(2000);
        } else {
          const isCourse = addedInfoList.length && (addedInfoList[0].type === KNG_TYPE.COURSE);
          let message = this.$t('pc_kng_kngcourse_msg_warning5'/* 发布成功！ */);
          if (isCourse && addedInfoList[0].shareFlag === 2) {
            message = this.$t('biz_msg_save_success'/* 保存成功 */);
          } else if (isCourse) {
            message = '';
          }
          if (message) {
            this.$message({
              message,
              type: 'success'
            });
            await sleep(2000);
          }
        }
        if (errorNumber || repeatNumber) return Promise.reject();
      } else if (repeatNumber || errorNumber) {
        let message = this.$t('pc_biz_lbl_uploadkngnumber'/** 已发布{0}个课件 */, [addedInfoList.length]);
        if (repeatNumber) message += this.$t('pc_biz_lbl_uploadkngexist'/** ，其中{0}个课件在该分类中已存在 */, [repeatNumber]);
        if (errorNumber) message += this.$t('pc_biz_lbl_uploadkngfail', [errorNumber]);
        await this.$confirm(
          message,
          this.$t('pc_biz_lbl_tip'/** 提示 */),
          {
            type: 'warning',
            showCancelButton: false
          }
        );
      }
      return Promise.resolve(addedInfoList.map((item, index) => ({...item, id: item.id || responses[index].kngId, ulcdCode: item.ulcdCode || responses[index].ulcdCode})));
    },
    async handleLocalTranscode(responses, list) {
      // 本地转码条件：私有云 && （创建 || 重新上传 || 转码失败）
      if (this.uploadConfig.privateEnv && list.length && (!this.isEdit || list[0].newFileId || list[0].status === 1)) {
        commonLog('006', '私有云转码准备');
        const data = list.map((item, index) => {
          return {
            url: item._keyPath,
            type: item._fileType,
            originName: item.fileName,
            fileId: item.newFileId || item.fileId,
            targetId: item.id || responses[index].kngId,
            zipType: [KNG_FILE_TYPE.ZIP, KNG_FILE_TYPE.SCORM, KNG_FILE_TYPE.HTML].includes(item.fileType) ? item.fileType : null,
            groupId: this.uploadConfig.serverId
          };
        });
        try {
          const fileIds = data.map(item => item.fileId).join(',');
          const kngIds = data.map(item => item.targetId).join(',');
          commonLog('006', this.uploadConfig.secretEndpoint, JSON.stringify(data), fileIds, kngIds);
          const res = await postLocalTranscode(this.uploadConfig.secretEndpoint, data);
          const fails = res.data.data.fails;
          if (fails && fails.length) {
            commonLog('006', '私有云转码失败kngId', fails.join(','));
            await putKngTransError(fails);
          }
        } catch (e) {}
      }
    },
    addCatalog(info) {
      const {catalogId, collegeId} = info;
      const data = {
        catalogId,
        collegeId,
        callback: data => this.updateCatalog(data, info)
      };
      this.$emit('onAddCatalog', data);
    },
    updateCatalog(data, info) {
      Object.assign(info, data);
      this.setCatalogData();
    }
  }
};
</script>
